import { Inject, Injectable, inject } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { CoBenefitType } from '../models/models.lib';
import { APP_CONFIG } from '../setup/config';
import { FormModes } from '../common/constants.lib';
import { environment } from '../../environments/environment';

const { apiUrl } = environment;

export abstract class EnvironerCoBenefitTypesService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    // const apiService = inject(ApiService);
    this.fetch().subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(): Observable<CoBenefitType[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/cobenefit/type/all`))
      .pipe(
        map((response: any, i) => {
          // console.log('fetch:map:response: ', response, i);
          // let returning =<CoBenefitType[]>response; // response.map(r =>  CoBenefitType.create((r)));
          // console.log('fetch:map:response: ', returning);
          return <CoBenefitType[]>response;
        }),
        map(r => r.map(x => CoBenefitType.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => {
          this.loading = false;
          // apiService.getCsrf();
        })
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class CoBenefitTypesService extends EnvironerCoBenefitTypesService {


  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http);
  }

  get() {
    return this.apiService.getHttpCall('cobenefit/type/all', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`cobenefit/type/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('cobenefit/type', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`cobenefit/type/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`cobenefit/type/${id}`, 'destroy');
  }

  addEdit(p: any, formMode: FormModes): Promise<any> {
    if (formMode === FormModes.NEW) {
      return this.add(p);
    } else {
      return this.update(p);
    }
  }

}
